import deepmerge from 'deepmerge';

import main from './main';

const hrf = {
  palette: {
    primary: {
      main: '#41A173'
    },
    secondary: {
      main: '#DFF4EB'
    }
  }
};

export default deepmerge(main, hrf);
